import { create } from "zustand";

interface RoleAnnouncementState {
	/** The last role change to read out, until replaced. */
	message: string;
	announce: (message: string) => void;
}

/** What `RoleSwitchAnnouncer` reads out after this tab switches role. */
export const useRoleAnnouncementStore = create<RoleAnnouncementState>(
	(set) => ({
		message: "",
		announce: (message) => set({ message }),
	}),
);
